import { useState } from "react";
import styles from "./orders.module.css";
import {
  Image,
  HeadingTitle,
  Ratings,
  Button,
  Pagination,
  Loader,
} from "../../../../components/shared/index";
import {
  useCancelOrderMutation,
  useGetOrdersQuery,
} from "../../../../queries/useOrderQuery";
import Swal from "sweetalert2";
import { FaDownload } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { useAddToCart } from "../../../../queries/useCartQuery";
import toast from "react-hot-toast";
import { getImageUrl } from "../../../../lib/get-image";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { Link, useNavigate } from "react-router-dom";
import { TbInvoice } from "react-icons/tb";
const Orders = () => {
  const navigate = useNavigate();
  const { data, isPending, error } = useGetOrdersQuery();
  const userOrdersHistory = data || [];
  const { mutate: addToCart } = useAddToCart();
  const cancelMutation = useCancelOrderMutation();
  const [addingId, setAddingId] = useState(null);
  const [cancellingOrderId, setCancellingOrderId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const per_page = 6;
  if (error) {
    return <Loader title="Failed to load orders..." />;
  }
  if (isPending) {
    return <Loader title="Loading Orders..." />;
  }
  if (!userOrdersHistory || userOrdersHistory.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>No orders found</p>
      </div>
    );
  }
  const orders = userOrdersHistory.map((order) => {
    const product = order?.order_products?.[0];
    return {
      id: order?.id,
      invoiceId: order?.invoice_id,
      productId: product?.product_id,
      vendorId: product?.product?.vendor_id,
      productSlug: product?.product?.slug,
      status: order?.order_status,
      quantity: product?.qty || 1,
      image:
        product?.product?.thumb_image ||
        "/assets/img/backgrounds/not_found.png",
      name: product?.product_name ?? "No Name",
      price: `${product?.unit_price || "0.00"}`,
      rating: product?.rating || 0,
      size: product?.size || "-",
      sku: product?.product?.sku || "-",
      salePrice: `${product?.unit_price || "0.00"}`,
      originalPrice: `${product?.unit_price || "0.00"}`,
      discount: product?.discount || "0% OFF",
    };
  });
  const indexOfLast = currentPage * per_page;
  const indexOfFirst = indexOfLast - per_page;
  const currentOrders = orders.slice(indexOfFirst, indexOfLast);
const handleCancelOrder = (order) => {
  Swal.fire({
    title: "Cancel this Order?",
    text: "Are you sure you want to cancel this order?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, Cancel",
    cancelButtonText: "No",
  }).then((result) => {
    if (result.isConfirmed) {
      setCancellingOrderId(order.id);

      cancelMutation.mutate(order.id, {
      onSuccess: () => {},

        onError: () => {
          toast.error("Failed to cancel order");
        },

        onSettled: () => {
          setCancellingOrderId(null);
        },
      });
    }
  });
};
  const handleAddToCart = (order) => {
    setAddingId(order?.id);
    addToCart(
      {
        product_id: order.productId,
        quantity: Number(order.quantity),
      },
      {
        onSuccess: () => {
          toast.success(`${order.name} added to cart`);
          setAddingId(null);
        },
        onError: () => {
          toast.error("Failed to add to cart");
          setAddingId(null);
        },
      }
    );
  };
  return ( 
    
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.ordersGrid}>
          {currentOrders?.map((order) => (
            <div key={order?.id} className={styles.orderCard}>
              <Link
                to={`/productdetails/${order?.productSlug}`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.imageWrapper}
              >
                <Image
                  src={getImageUrl(order?.image)}
                  alt={order?.name}
                  className={styles.productImage}
                />
              </Link>
              <div className={styles.cardContent}>
                <HeadingTitle text={order?.name} style={styles.productName} />
              
              <div className={styles.rating}>
  {order.rating > 0 && <Ratings rating={order.rating} />}
</div>
                <div className={styles.info}>
               
                  <span className={styles.infoText}>SKU: {order?.sku}</span>
                </div>
                {/* <div className={styles.priceRow}>
                  <span className={styles.salePrice}>
                    <LiaRupeeSignSolid size={20} />
                    {order?.salePrice}
                  </span>
                  <span className={styles.originalPrice}>
                    <LiaRupeeSignSolid size={20} />
                    {order?.originalPrice}
                  </span>
                  <span className={styles.discount}>{order.discount}</span>
                </div> */}
                <Button
                  type="button"
                  disabled={
                    order?.status === "cancelled" || addingId === order?.id
                  }
                  title={
                    order?.status === "cancelled"
                      ? "Unavailable"
                      : addingId === order?.id
                      ? "Adding..."
                      : "Buy Again"
                  }
                  style={`${styles.addToCart} ${
                    order.status === "cancelled" ? styles.addToCartDisabled : ""
                  }`}
                  onHandler={() => handleAddToCart(order)}
                />
               {order.status === "cancelled" ? (
  <div className={styles.cancelledBadge}>Order Cancelled</div>
) : order.status === "delivered" ? null : (
  <Button
    type="button"
    title="Cancel Order"
    style={styles.cancelButton}
    isLoading={
      cancellingOrderId === order?.id &&
      cancelMutation.isPending
    }
    disabled={
      cancellingOrderId === order?.id &&
      cancelMutation.isPending
    }
    onHandler={() => handleCancelOrder(order)}
  />
)}
                {order?.status === "delivered" && (
                  <Button
                    title="Write a Review"
                    style={styles.writeReviewBtn}
                    onHandler={() =>
                      navigate("/review/add", {
                        state: {
                          productId: order?.productId,
                          vendorId: order?.vendorId,
                        },
                      })
                    }
                  />
                )}
                <Button
                  type="button"
                  title={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.3rem",
                      }}
                    >
                   <FiDownload size={18} />
                    </span>
                  }
                  style={styles.invoiceButton}
                  onHandler={() =>
                    navigate(`/invoice/${order?.invoiceId}`)
                  }
                />
              </div>
            </div>
          ))}
        </div>
        {orders?.length > per_page && (
          <div className={styles.paginationWrapper}>
            <Pagination
              currentPage={currentPage}
              total={orders.length} 
              per_page={per_page}
              handlePageChange={setCurrentPage}
            />
          </div>
        )}
      </div> 
    </section>
  );
};
export default Orders;